export default __webpack_public_path__ + "static/media/ETH-HKG-ICL-2025.a6604bec.pdf";